var _regeneratorRuntime = require("C:\\Users\\vinayak\\Documents\\GitHub\\Barcode_reader_PWA\\barcode-reader\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\vinayak\\Documents\\GitHub\\Barcode_reader_PWA\\barcode-reader\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var UTILITIES = require('./utiltities');
/* eslint-disable */


var BARCODE_DECODERS = {
  'code-128': require('./code-128'),
  'code-2of5': require('./2of5'),
  'code-39': require('./code-39'),
  'code-93': require('./code-93'),
  'ean-13': require('./ean-13'),
  'ean-8': require('./ean-8'),
  codabar: require('./codabar')
  /* eslint-enable */

  /**
   * Scans and returns barcode from the provided image
   *
   * @param {*} image Image element || Canvas || ImageData || Image Path in Node.js
   * @param {Object} options Options defining type of barcode to detect
   * @param {String} options.barcode Barcode name
   * @param {String=} options.type Type of Barcode
   * @returns {String} Extracted barcode string
   */

};

function barcodeDecoder(_x, _x2) {
  return _barcodeDecoder.apply(this, arguments);
}

function _barcodeDecoder() {
  _barcodeDecoder = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(image, options) {
    var list, _ref, data, width, height, channels, spoints, numLines, slineStep, start, end, _UTILITIES$getLines, lines, padding, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // eslint-disable-next-line
            options.barcode = options.barcode.toLowerCase();
            list = Object.keys(BARCODE_DECODERS);

            if (!(list.indexOf(options.barcode) === -1)) {
              _context.next = 4;
              break;
            }

            throw new Error("Invalid barcode specified. Available decoders: ".concat(list, ". https://github.com/mubaidr/Javascript-Barcode-Reader#available-decoders"));

          case 4:
            _context.next = 6;
            return UTILITIES.getImageDataFromSource(image);

          case 6:
            _ref = _context.sent;
            data = _ref.data;
            width = _ref.width;
            height = _ref.height;
            channels = data.length / (width * height); // check points for barcode location

            spoints = [1, 9, 2, 8, 3, 7, 4, 6, 5];
            numLines = spoints.length;
            slineStep = height / (numLines + 1); // eslint-disable-next-line

          case 14:
            if (!(numLines -= 1)) {
              _context.next = 26;
              break;
            }

            // create section of height 2
            start = channels * width * Math.floor(slineStep * spoints[numLines]);
            end = channels * width * Math.floor(slineStep * spoints[numLines]) + 2 * channels * width; // const pxLine = data.slice(start, end)
            // const { lines, padding } = UTILITIES.getLines({

            _UTILITIES$getLines = UTILITIES.getLines({
              data: data,
              start: start,
              end: end,
              width: width,
              height: height,
              channels: channels
            }), lines = _UTILITIES$getLines.lines, padding = _UTILITIES$getLines.padding;

            if (!(lines && lines.length !== 0)) {
              _context.next = 24;
              break;
            }

            // remove empty whitespaces on side of barcode
            if (padding.left) lines.shift();
            if (padding.right) lines.pop(); // Run the decoder

            result = BARCODE_DECODERS[options.barcode](lines, options.type);

            if (!result) {
              _context.next = 24;
              break;
            }

            return _context.abrupt("return", result);

          case 24:
            _context.next = 14;
            break;

          case 26:
            throw new Error('Failed to extract barcode!');

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _barcodeDecoder.apply(this, arguments);
}

if (module && module.exports) {
  module.exports = barcodeDecoder;
} else {
  global.javascriptBarcodeReader = barcodeDecoder;
}